import React from "react";
import CrudManager from "./CrudManager";

export default function BoardManager() {
    return (
        <CrudManager
            testId="admin-board"
            resource="/admin/board"
            title="Junta directiva"
            idField="id"
            columns={[
                { key: "order", label: "#" },
                { key: "name", label: "Nombre" },
                { key: "role", label: "Cargo" },
            ]}
            fields={[
                { name: "name", label: "Nombre", required: true },
                { name: "role", label: "Cargo", required: true },
                { name: "bio", label: "Biografía breve", type: "textarea", rows: 3 },
                { name: "photo", label: "URL foto" },
                { name: "linkedin", label: "URL LinkedIn" },
                { name: "order", label: "Orden", type: "number" },
            ]}
            defaultValues={{ name: "", role: "", bio: "", photo: "", linkedin: "", order: 0 }}
        />
    );
}
